<template>
  <VaSidebar v-model="writableVisible" :width="sidebarWidth" :color="color" minimized-width="0">
    <VaAccordion v-model="value" multiple>
      <VaCollapse v-for="(route, index) in menuObj.routes" :key="index">
        <template #header="{ value: isCollapsed }">
          <VaSidebarItem
            :to="route.children ? undefined : { name: route.name }"
            :active="routeHasActiveChild(route)"
            :active-color="activeColor"
            :text-color="textColor(route)"
            :aria-label="`${route.children ? 'Open category ' : 'Visit'} ${t(route.displayName)}`"
            role="button"
            hover-opacity="0.10"
          >
            <VaSidebarItemContent class="py-3 pr-2 pl-4">
              <VaIcon
                v-if="route.meta.icon"
                aria-hidden="true"
                :name="route.meta.icon"
                size="20px"
                :color="iconColor(route)"
              />
              <VaSidebarItemTitle class="flex justify-between items-center leading-5 font-semibold">
                {{ t(route.displayName) }}
                <VaIcon v-if="route.children" :name="arrowDirection(isCollapsed)" size="20px" />
              </VaSidebarItemTitle>
            </VaSidebarItemContent>
          </VaSidebarItem>
        </template>
        <template #body>
          <div v-for="(childRoute, index2) in route.children" :key="index2">
            <VaSidebarItem
              :to="{ name: childRoute.name }"
              :active="isActiveChildRoute(childRoute)"
              :active-color="activeColor"
              :text-color="textColor(childRoute)"
              :aria-label="`Visit ${t(route.displayName)}`"
              hover-opacity="0.10"
            >
              <VaSidebarItemContent class="py-3 pr-2 pl-11">
                <VaSidebarItemTitle class="leading-5 font-semibold">
                  {{ t(childRoute.displayName) }}
                </VaSidebarItemTitle>
              </VaSidebarItemContent>
            </VaSidebarItem>
          </div>
        </template>
      </VaCollapse>
    </VaAccordion>
    <div class="user-info">
      <div style="display:flex;align-items: center;">
         <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />
          <div>
          <div class="info-item">
            <span class="nickname">{{ info.user.nickName }}</span>
          </div>
          <div class="info-item">
            <span class="account">{{ info.user.username }}</span>
          </div>
       </div>
      </div>
    </div>
  </VaSidebar>
</template>
<script lang="ts">
import ProfileDropdown from '../navbar/components/dropdowns/ProfileDropdown.vue'
import { defineComponent, watch, ref, computed, onMounted, onBeforeMount, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'
//平台管理员
import navigationRoutes, { type INavigationRoute } from './NavigationRoutes'
//店铺管理员
import Storemanager, { type INavigationRoute2 } from './Storemanager'
import Storeuser, { type INavigationRoute3 } from './Storeuser'
import { on } from 'stream'
import { getCurrentUser } from '@/api/index'

export default defineComponent({
  name: 'Sidebar',
  props: {
    visible: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
    roleType: { type: String, default: '1' },
  },
  emits: ['update:visible'],

  setup: (props, { emit }) => {
    const { getColor, colorToRgba } = useColors()
    const route = useRoute()
    const { t } = useI18n()

    const value = ref<boolean[]>([])

    const writableVisible = computed({
      get: () => props.visible,
      set: (v: boolean) => emit('update:visible', v),
    })

    const isActiveChildRoute = (child: INavigationRoute) => route.name === child.name

    const routeHasActiveChild = (section: INavigationRoute) => {
      if (!section.children) {
        return route.path.endsWith(`${section.name}`)
      }

      return section.children.some(({ name }) => route.path.endsWith(`${name}`))
    }

    const menuObj = reactive({
      root: {},
      routes: [],
    })
    const setActiveExpand = () =>
      (value.value = menuObj.routes.map((route: INavigationRoute) => routeHasActiveChild(route)))

    const sidebarWidth = computed(() => (props.mobile ? '100vw' : '280px'))
    const color = computed(() => getColor('background-secondary'))
    const activeColor = computed(() => colorToRgba(getColor('focus'), 0.1))

    const iconColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'secondary')
    const textColor = (route: INavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'textPrimary')
    const arrowDirection = (state: boolean) => (state ? 'va-arrow-up' : 'va-arrow-down')

    let info = reactive({
      user: {
        nickName: '',
        username: ''
      }
    })
    const getUserInfo = () => {
      getCurrentUser().then((res) => {
        if(res.code == 200) {
          console.log('111111111111',res.data)
          let userinfo = res.data
          info.user.nickName = userinfo.user.nickName
          info.user.username = userinfo.user.username
        }
      })
      }
    onMounted(() => {
      //1平台管理员 2店铺管理员 3店铺用户
      if (props.roleType == '1') {
        menuObj.root = navigationRoutes.root
        menuObj.routes = navigationRoutes.routes
      } else if (props.roleType == '2') {
        menuObj.root = Storemanager.root
        menuObj.routes = Storemanager.routes
      } else if (props.roleType == '3') {
        menuObj.root = Storeuser.root
        menuObj.routes = Storeuser.routes
      } else {
        menuObj.root = navigationRoutes.root
        menuObj.routes = navigationRoutes.routes
      }
      getUserInfo()
    })

    watch(() => route.fullPath, setActiveExpand, { immediate: true })

    return {
      writableVisible,
      sidebarWidth,
      value,
      color,
      activeColor,
      navigationRoutes,
      Storemanager,
      Storeuser,
      menuObj,
      routeHasActiveChild,
      isActiveChildRoute,
      t,
      iconColor,
      textColor,
      arrowDirection,
      info
    }
  },
})
</script>
<style lang="scss"> 
.user-info {
    position: fixed;
    left: 20px;  /* 距离左边 20px */
    bottom: 20px;  /* 距离底部 20px */
    padding: 10px;  /* 适当的内边距 */
    border-radius: 5px;  /* 圆角 */
    font-size: 14px;  /* 文字大小 */
    z-index: 1000;  /* 确保在其他元素之上 */
  
}

/* 调整内部信息项 */
.info-item {
    margin-bottom: 5px;  /* 每一项之间的间距 */
}

.info-item {
  display: flex;
  justify-content: center; /* 标签和信息左右对齐 */
  align-items: flex-start; /* 上下对齐 */
}

.label {
  font-weight: bold;
  color: #333;
  font-size: 14px;
  text-align: right;
}

.nickname,
.account {
  color: #666;
  font-size: 14px;
  text-align: center; /* 信息部分左对齐 */
}

.nickname {
  font-weight: bold;
  font-size: 16px;
  color:#000000;
}

.account {
  font-weight: normal;
}

</style>
